// Polyfills
import Stickyfill from "stickyfilljs";

// Vendors
import Parallax from "parallax-js";
// import { TweenMax, Power2 } from "gsap";

// Utilities
import Config from "../constants/Config";
import { qsa, qs, cls, data } from "./util/dom-utils";
import pubsub from "./util/pubsub";

// Elements
let $els = qsa(".js-section", document);

class Sections {
    constructor(el) {
        // Elements
        this.$el = el;

        this.$character = qs(".character", this.$el);
        this.currentSection = 0;

        this.attachEvents();
    }

    observerScroll() {
        // IntersectionObserver Supported
        let options = {};

        if(!window.Modernizr.touch) {
            options = {
                root: null,
                rootMargin: "40px",
                threshold: [0, 0.25, 0.5, 0.75, 1]
            };
        }

        const actionOnChange = (el, index) => {
            if (!cls.has(el, Config.classes.VISIBLE)) {
                cls.add(el, Config.classes.VISIBLE);
            }

            pubsub.publish(Config.events.SECTION_CHANGE, index);
        }

        // Create new IntersectionObserver
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                let el = entry.target;
                const indexEl = data("index", el);

                if(window.Modernizr.touch) {
                    if (entry.isIntersecting) {
                        actionOnChange(el, indexEl);
                    }
                }
                else {
                    if (entry.intersectionRatio >= 0.5) {
                        actionOnChange(el, indexEl);
                    }
                }
            
            });

        }, options);

        // Start observing 
        observer.observe(this.$el)

    }

    parallaxHandler(id) {

        if (this.parallaxInstance) {

            if (id === this.parallaxInstance._id) {
                this.parallaxInstance.enable();
            }
            else {
                this.parallaxInstance.disable();
            }
        }

    }

    setActiveSection(id) {

        $els.forEach((section, i) => {
            cls.remove(section, "is-active");

            if (parseInt(id) === i) {

                cls.add(section, "is-active");
            }
        });

    }

    attachEvents() {

        if (!window.Modernizr.touch) {
            if (!(/Edge\/\d./i.test(navigator.userAgent))) {
                if (this.$character) {
                    const svg = qs(".character__svg", this.$character);
                    const id = data("id", svg);

                    this.parallaxInstance = new Parallax(svg, {
                        selector: ".svg__layer"
                    });

                    this.parallaxInstance._id = id;

                }
            }
        }


        // enable / disable parallax on section change
        pubsub.subscribe(Config.events.PAGINATION_CHANGE, (id) => {
            this.parallaxHandler(id);
            this.setActiveSection(id);
        });


        this.observerScroll();


        // Polyfill position sticky browsers <= IE11
        const characters = qsa(".character");
        Stickyfill.add(characters);

    }


}

export default Sections;

const _init = () => {

    if ($els.length) {
        $els.forEach((el, i) => {
            el.setAttribute("data-index", i);
            new Sections(el);
        });
    }
};

_init();
